import type { AcuityEffectiveScore, CurrentAcuityScoreResponse } from "@/core/types";
import { AcuityScoreChange } from "@/features/acuity/components/AcuityScoreChange";

import { getFormattedAcuityDate } from "../helpers/getFormattedAcuityDate";
import { PatientData } from "../../components/PatientData";

type PendingAcuityIndexProps = CurrentAcuityScoreResponse;

export function PendingAcuityIndex({
  approval_requests,
  effective_score,
}: PendingAcuityIndexProps) {
  /**
   * MANUAL requests take priority over AUTO — show the clinician-initiated override first.
   * When types are equal, original order is preserved (stable sort).
   */
  const sortedPendingRequests = [...approval_requests].sort((a, b) => {
    if (a.type === "MANUAL" && b.type !== "MANUAL") return -1;
    if (a.type !== "MANUAL" && b.type === "MANUAL") return 1;

    return 0;
  });

  const [pendingApprovalRequestRequest] = sortedPendingRequests;
  const { requested_at, score: requestedScore } = pendingApprovalRequestRequest;
  const { score: currentScore } = effective_score;

  return (
    <>
      <PatientData
        className="tw:flex tw:items-baseline"
        classNameChildren="tw:flex"
        label="Acuity Index"
      >
        <AcuityScoreChange
          currentScore={currentScore}
          isLabelled={false}
          newScore={requestedScore}
        />
      </PatientData>
      {requested_at && <Label requested_at={requested_at} />}
    </>
  );
}

function Label({ requested_at }: Pick<AcuityEffectiveScore, "requested_at">) {
  const formattedDate = getFormattedAcuityDate(requested_at);

  return (
    <PatientData
      className="tw:text-sm tw:text-text-tertiary tw:*:font-normal"
      label="Pending Override"
    >
      {formattedDate}
    </PatientData>
  );
}
